var _defs, _polygon, _polyline, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC4WwwIconsWhiteSmartHomeOs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Line_Work",
    "data-name": "Line Work",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-2{stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C4_WWW_Icons_White") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "81.42 78.95 81.42 42.67 50 17.49 18.58 42.67 18.58 78.95 81.42 78.95"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "87.81 41.47 50 10.45 11.98 41.47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.09,46.36a11.51,11.51,0,0,1,4.23,4.14,11.12,11.12,0,0,1,0,11.36A11.59,11.59,0,0,1,47.09,66a11.57,11.57,0,0,1-11.57,0,11.71,11.71,0,0,1-4.22-4.17,11.12,11.12,0,0,1,0-11.36,11.63,11.63,0,0,1,4.22-4.14,11.7,11.7,0,0,1,11.57,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.27,63.94a9,9,0,0,0,3.25,2.19,10.43,10.43,0,0,0,4,.81,8.62,8.62,0,0,0,5.09-1.36A4.2,4.2,0,0,0,69.51,62a4.35,4.35,0,0,0-.88-2.85,6.11,6.11,0,0,0-2.18-1.68,29.64,29.64,0,0,0-3.51-1.27,30.09,30.09,0,0,1-3.66-1.34A6.12,6.12,0,0,1,57,53,5,5,0,0,1,56,49.85a4.26,4.26,0,0,1,2-3.65,9,9,0,0,1,5.23-1.37,12.06,12.06,0,0,1,3.21.45,10,10,0,0,1,2.78,1.19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC4WwwIconsWhiteSmartHomeOs);
export default __webpack_public_path__ + "static/media/C4_WWW_Icons_White-Smart-Home-OS.0bbd71821bd14f3ed407109fa8fdb790.svg";
export { ForwardRef as ReactComponent };